import { fork, call, put, select, take } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'

import * as fromRecurrence from '@src/redux/modules/recurrence'
import { recurrences } from '@src/services/api'

import * as fromAuth from '@src/redux/modules/auth'

// /////////////////////////////////////////////////////////////////////////////
// Sagas
// /////////////////////////////////////////////////////////////////////////////
export function * fetch (action) {
  yield put({ type: fromRecurrence.FETCH_STARTED })

  const currentUserId = yield select(fromAuth.getCurrentUser)
  const { recurrenceId } = action.payload

  const { response, error } = yield call(recurrences.fetch, currentUserId, recurrenceId)

  if (error) {
    return yield put({
      type: fromRecurrence.FETCH_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromRecurrence.FETCH_SUCCESS,
    payload: response
  })
}

export function * update (action) {
  yield put({type: fromRecurrence.UPDATE_STARTED})

  const { recurrenceId, props } = action.payload
  const userId = yield select(fromAuth.getCurrentUser)

  const { response, error } = yield call(recurrences.update, userId, recurrenceId, props)

  if (error) {
    return yield put({
      type: fromRecurrence.UPDATE_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromRecurrence.UPDATE_SUCCESS,
    payload: response
  })

  if (action.meta && action.meta.onComplete) {
    yield call(action.meta.onComplete)
  }
}

export function * cancel (action) {
  yield put({ type: fromRecurrence.CANCEL_STARTED })

  const currentUserId = yield select(fromAuth.getCurrentUser)
  const { recurrenceId } = action.payload

  const { response, error } = yield call(recurrences.cancel, currentUserId, recurrenceId)

  if (error) {
    return yield put({
      type: fromRecurrence.CANCEL_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromRecurrence.CANCEL_SUCCESS,
    payload: response
  })

  if (action.meta && action.meta.onComplete) {
    yield call(action.meta.onComplete)
  }
}

export function * fetchPenalty (action) {
  yield put({ type: fromRecurrence.FETCH_PENALTY_STARTED })

  const currentUserId = yield select(fromAuth.getCurrentUser)
  const { recurrenceId, recurrenceChanges, method } = action.payload

  const { response, error } = yield call(recurrences.fetchPenalty, currentUserId, recurrenceId, recurrenceChanges, method)

  if (error) {
    return yield put({
      type: fromRecurrence.FETCH_PENALTY_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromRecurrence.FETCH_PENALTY_SUCCESS,
    payload: response
  })
}

// /////////////////////////////////////////////////////////////////////////////
// Watchers
// /////////////////////////////////////////////////////////////////////////////
export function * watchFetch () {
  yield fork(takeEvery, fromRecurrence.FETCH, fetch)
}

export function * watchUpdate () {
  yield fork(takeEvery, fromRecurrence.UPDATE, update)
}

export function * watchCancel () {
  while (true) {
    const action = yield take(fromRecurrence.CANCEL)
    yield call(cancel, action)
  }
}

export function * watchFetchPenalty () {
  yield fork(takeEvery, fromRecurrence.FETCH_PENALTY, fetchPenalty)
}

// /////////////////////////////////////////////////////////////////////////////
// Root Saga
// /////////////////////////////////////////////////////////////////////////////
export default function * rootSaga () {
  yield * [
    fork(watchFetch),
    fork(watchUpdate),
    fork(watchCancel),
    fork(watchFetchPenalty)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/recurrence.js